import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import Parse from 'parse';

/**
 * Confirm soft-deletion (deactivation) of a display currency.
 */
const DeleteCurrencyDialog = ({ open, onClose, onDeleted, currency }) => {
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  const handleDelete = async () => {
    setError('');
    setDeleting(true);
    try {
      await Parse.Cloud.run('deleteCurrency', { currencyId: currency.id });
      onDeleted('Currency deleted successfully');
      onClose();
    } catch (err) {
      setError(err.message || 'Failed to delete currency');
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { backgroundColor: '#242424', color: '#fff' } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#F44336' }}>
        <WarningAmberIcon /> Delete Currency
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ color: '#fff' }}>
          Are you sure you want to delete the currency <strong>{currency?.code}</strong>?
        </Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: 13, mt: 1 }}>
          It will be deactivated. Currencies currently enabled for an operator cannot be deleted.
        </Typography>
        {error && (
          <Box sx={{ mt: 2 }}>
            <Typography sx={{ color: '#F44336', fontSize: 13 }}>{error}</Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} sx={{ color: 'rgba(255,255,255,0.7)' }}>
          Cancel
        </Button>
        <Button onClick={handleDelete} variant="contained" color="error" disabled={deleting}>
          {deleting ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteCurrencyDialog;
